var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex justify-between items-center px-4"},[_c('AImage',{attrs:{"paths":[{ url: this.logoPath, name: 'logo' }],"classList":"h-22 w-22"}}),(!_vm.noBreadcrumb)?_c('MBreadcrumb'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }